import React from "react";
import "./ResilienceSelector.css";

const ResilienceSelector = (props) => {
  const { resilienceLabel,
          resilienceValues,
          selectedResilienceValue,
          setSelectedResilienceValue
         } = props;

  const resilienceMap = {
    "Low": 1.0,
    "Medium": 0.6,
    "High": 0.2,
  };

  const handleResilienceChange = (e) => {
    setSelectedResilienceValue(resilienceMap[e]);
  }
  
  return (
    <div className="resilience-selector-container">
      <div className="resilience-selector">
          <div className="resilience-label">{resilienceLabel}</div>
        {resilienceValues.map((temp) => (
          <div
            key={temp}
            className={`resilience-option ${
              selectedResilienceValue === resilienceMap[temp] ? "selected" : ""
            }`}
            onClick={() => handleResilienceChange(temp)}
          >
            {temp}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ResilienceSelector;